module.exports = "pegasus/assets/theme2/facebook.png";